import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommunicationSummary, CommunicationsService } from 'src/app/services/communications.service';
import { CommunicationInfoModalComponent } from '../communication-info-modal/communication-info-modal.component';

@Component({
  selector: 'app-communications-table',
  templateUrl: './communications-table.component.html',
  styleUrls: ['./communications-table.component.scss']
})
export class CommunicationsTableComponent implements OnInit, OnDestroy {

  communicationsSummary: CommunicationSummary[];
  filter = new FormControl('');

  unsubscribe: Subject<any> = new Subject();

  @ViewChild('commInfoModal', { static: false }) commInfoModal: CommunicationInfoModalComponent;

  constructor(private communicationsService: CommunicationsService) { }

  ngOnInit() {
    this.communicationsService.getCommunicationsSummary();

    this.communicationsService.communicationsSummary
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(summary => {
        if (summary) {
          this.communicationsSummary = summary;
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  showCommunication(communicationId: number) {
    this.commInfoModal.open(communicationId).catch((error) => console.warn(`Communication Info Modal Error: ${error}`))
  }
}
